import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { groupSupplierDocuments } from 'features/supplier/utils';

import AddSafetyInformation from '@features/supplier/component/AddSafetyInformation';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { fetchEnumValues } from '@services/commonService';
import { fetchSafetyInformation } from '@services/supplierOnboardingService';

import { getFileType, getIconByFileType, printApiError } from '@utils/Util';

const SafetyInformation = () => {
	const [isShowEdit, setIsShowEdit] = useState(false);
	const [safetyInfo, setSafetyInfo] = useState({});
	const [documentTypes, setDocumentTypes] = useState([]);
	const { id } = useParams();
	const dispatch = useDispatch();

	const getSafetyInfo = async () => {
		try {
			dispatch(openLoader());
			const data = await fetchSafetyInformation(id);
			setSafetyInfo(data);
			dispatch(closeLoader());
		} catch (e) {
			dispatch(closeLoader());
			printApiError(e);
		}
	};

	const fetchDocumentTypes = async () => {
		try {
			dispatch(openLoader());
			const data = await fetchEnumValues('info.nitex.app.supplier.SafetyDocumentType');
			setDocumentTypes(data?.map((item) => ({ id: item.constant, value: item.name })));
			dispatch(closeLoader());
		} catch (e) {
			dispatch(closeLoader());
			printApiError(e);
		}
	};

	useEffect(() => {
		(async () => {
			await Promise.all([fetchDocumentTypes(), getSafetyInfo(), getSafetyInfo()]);
		})();
	}, [id]);

	const onCloseModal = async (reload = false) => {
		if (reload === true) {
			await getSafetyInfo();
		}
		setIsShowEdit(false);
	};

	const renderDocuments = () => {
		if (safetyInfo?.documentResponseList?.length > 0) {
			const groupedDocuments = groupSupplierDocuments(
				safetyInfo.documentResponseList,
				'safetyDocumentType'
			);
			return Object.keys(groupedDocuments)?.map((item) => {
				const selectedType = documentTypes.find((type) => type.id === item);
				return (
					<div
						className="single text-left same-padding-box d-flex flex-column justify-content-start"
						key={`supporting_doc_${item}`}
					>
						<p className="gray_dark_02 regular-14 mb-12">{selectedType?.value}</p>
						<div className="d-flex flex-wrap">
							{groupedDocuments[item]?.map((doc) => {
								let fileType;
								if (doc.documentResponse.docUrl) {
									fileType = getFileType(doc.documentResponse.docUrl);
								} else {
									fileType = getFileType(doc.documentResponse.name);
								}

								return (
									<div
										key={`doc_${doc.documentResponse.id}`}
										className="addition-info d-flex align-items-center cursor-pointer"
										onClick={() => window.open(doc.documentResponse.docUrl, '_blank')}
									>
										<img src={getIconByFileType(fileType)} alt="" width={19} />
										<p className="regular-12 pl-1">{doc.documentResponse.name}</p>
									</div>
								);
							})}
						</div>
					</div>
				);
			});
		}
	};

	return (
		<>
			<div className="safety-info hover-section section-padding">
				<h3 className="suplier-title pb-4 font-weight-bold regular-16">
					Safety Information
					<span className="ml-12">
						<button
							className="blue border-0 medium-14 bg-transparent"
							onClick={() => setIsShowEdit(true)}
						>
							Edit
						</button>
					</span>
				</h3>
				<div className="info-items">
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Number of Floors</p>
						<h3 className="title regular-18 weight-600">{safetyInfo?.noOfFloors}</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Size of Floor (Sqft.)</p>
						<h3 className="title regular-18 weight-600">{safetyInfo?.sizeOfFloors}</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Total Space (Sqft.)</p>
						<h3 className="title regular-18 weight-600">{safetyInfo?.totalSpace}</h3>
					</div>
					<div className="single text-left same-padding-box d-flex flex-column justify-content-center">
						<p className="gray_dark_02 regular-14">Total Areas of Factory Premises (Sqft.)</p>
						<h3 className="title regular-18 weight-600">
							{safetyInfo?.totalAreaOfFactoryPremise}
						</h3>
					</div>
				</div>
				<div className="saftey-pdf-items info-items mt-3">{renderDocuments()}</div>
			</div>
			{isShowEdit && (
				<AddSafetyInformation
					onClose={onCloseModal}
					safetyInfo={safetyInfo}
					callBack={getSafetyInfo}
					documentTypes={documentTypes}
				/>
			)}
		</>
	);
};

export default SafetyInformation;
